module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'HomeView'
      }
    }
  }, [_vm._v("\n      豆瓣\n    ")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "color": "#2384E8"
    },
    attrs: {
      "to": {
        name: 'MovieView'
      }
    }
  }, [_vm._v("\n        电影\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "#9F7860"
    },
    attrs: {
      "to": {
        name: 'BookView'
      }
    }
  }, [_vm._v("\n        图书\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "#E4A813"
    },
    attrs: {
      "to": {
        name: 'StatusView'
      }
    }
  }, [_vm._v("\n        广播\n      ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticStyle: {
      "color": "#2AB8CC"
    },
    attrs: {
      "to": {
        name: 'GroupView'
      }
    }
  }, [_vm._v("\n        小组\n      ")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "talion",
    on: {
      "click": _vm.showTalion
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8463e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 196
// module chunks = 0